/* Svensk katalog for locale-investments.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'investments.reviewAndEdit': 'Kontrollera och redigera',
  'investments.editSourceFact': 'Redigera källuppgift',
  'investments.correctedSourceFactHelp': 'Rätta bara uppgifter som du har kontrollerat mot originaldokumentet. Ändringen loggas med användare och tidpunkt.',
  'investments.saveCorrection': 'Spara rättelse',
  'investments.addOptionalComment': 'Lägg till kommentar (valfritt)',
  'investments.reviewNoteOptional': 'Kommentar till kontrollen (valfritt)',
  'investments.openingReconciliation': 'IB investeringar mot huvudboken',
  'investments.openingReconciliationHelp': 'Visade ingående investeringar jämförs med investeringskontona i den ingående balansen. Avvikelser upp till och med {{tolerance}} godtas.',
  'investments.openingRegisterValue': 'Visade investeringar',
  'investments.openingLedgerValue': 'IB huvudbok',
  'investments.total': 'Summa',
  'investments.openingLedgerMismatch': 'Ingående investeringar och huvudbok är inte avstämda.',
  'investments.details': 'Detaljer',
  'investments.eventDetails': 'Händelsedetaljer',
  'investments.holdingDetails': 'Innehavsdetaljer',
  'investments.amount': 'Belopp',
  'investments.openingRepairTaxReason': 'Skattebehandlingen måste bekräftas mot årsbesked eller annan dokumentation.',
  'investments.openingRepairReason': 'Ingående innehav dokumenterat och kontrollerat före försäljningen.',
  'investments.authenticationRequired': 'Logga in för att använda investeringsregistret.',
  'investments.businessInvalid': 'Välj ett giltigt företag.',
  'investments.businessNotFound': 'Företagets bokföringsdata finns inte.',
  'investments.operationFailed': 'Åtgärden kunde inte slutföras. Försök igen.',
  'investments.measurement': 'Dokumenterad värderingsprincip',
  'investments.cost': 'Anskaffningsvärde med nedskrivning',
  'investments.fair_value': 'Verkligt värde (villkoren är dokumenterade)',
  'investments.measurementReview': 'Välj och dokumentera värderingsprincipen. Verkligt värde kräver kvalificerande omsättningstillgångar.',
  'investments.valueAboveCost': 'Bokfört värde får inte överstiga anskaffningsvärdet enligt vald princip.',
  'investments.duplicateInstrument': 'Investeringsklassen är redan registrerad. Använd samma investering för alla depåer.',
  'investments.receiptAlreadyBooked': 'Verifikationen är redan bokförd. Använd företagsdokument för dokumentation som omfattar flera händelser.',
  'investments.bankMatched': 'Kopplad till bank',
  'investments.matchBank': 'Stäm av mot bankrad',
  'investments.bankMatchInvalid': 'Bankraden kan inte kopplas. Uppdatera och kontrollera datum, belopp och konto.',
  'investments.bankUnmatchRequired': 'Öppna bankkopplingen i bankavstämningen innan händelsen återförs.',
  'investments.acquisitionDate': 'Ursprungligt anskaffningsdatum (FIFO)',
  'nav.investeringer': 'Investeringar',
  'route.investeringer': 'Investeringar',
  'navhelp.investeringer': 'Aktier, fonder och tillhörande bokföring.',
  'investments.title': 'Investeringar',
  'investments.subtitle': 'Aktier, fonder och dokumenterade händelser',
  'investments.newInstrument': 'Ny investering',
  'investments.newEvent': 'Ny händelse',
  'investments.name': 'Namn',
  'investments.kind': 'Typ',
  'investments.share': 'Aktie',
  'investments.fund': 'Fond',
  'investments.isin': 'ISIN (valfritt)',
  'investments.issuerCountry': 'Emittentens land (landskod)',
  'investments.accountCode': 'Balanskonto',
  'investments.valuationAccountCode': 'Konto för värdejustering',
  'investments.taxTreatment': 'Skattebehandling',
  'investments.accountSource.saved_instrument': 'För vidare kontot som redan är sparat för investeringen.',
  'investments.accountSource.opening_balance': 'Föreslaget utifrån entydigt namn och saldo i den ingående balansen.',
  'investments.accountSource.manual': 'Kontot är valt manuellt och används vidare för investeringen.',
  'investments.accountSource.default': 'Inget entydigt historiskt konto hittades. 1810 föreslås utan att bokföringen stoppas.',
  'investments.review': 'Måste klargöras',
  'investments.exempt': 'Inom fritaksmetoden',
  'investments.taxable': 'Fullt skattepliktig',
  'investments.mixed': 'Blandad aktie- och räntedel',
  'investments.taxReason': 'Underlag för skattebehandlingen',
  'investments.instrumentId': 'Investering',
  'investments.choose': 'Välj',
  'investments.instrumentScope': 'Registreringen gäller NOK och NRS 8. Bekräfta land, regelverk och skattekategori mot dokumentationen. Kombinationsfonder måste klargöras separat.',
  'investments.date': 'Bokföringsdatum',
  'investments.reference': 'Unik transaktionsreferens',
  'investments.quantity': 'Antal',
  'investments.provider': 'Leverantör / depå',
  'investments.targetProvider': 'Ny depå',
  'investments.lotId': 'Skattemässig anskaffningspost',
  'investments.gross': 'Brutto vederlag / utdelning',
  'investments.fees': 'Omkostnader / arvode',
  'investments.bookCost': 'Redovisningsmässigt anskaffningsvärde',
  'investments.bookValue': 'Bokfört värde',
  'investments.taxCost': 'Skattemässigt anskaffningsvärde',
  'investments.settlementAccount': 'Avräkningskonto',
  'investments.evidence': 'Dokumentation',
  'investments.taxConfirmed': 'Jag har kontrollerat skattebehandlingen för händelsen och inkomståret.',
  'investments.opening': 'Ingående innehav',
  'investments.purchase': 'Köp',
  'investments.sale': 'Försäljning',
  'investments.dividend': 'Utdelning',
  'investments.annual_income': 'Årsrapporterad ränteuppgift',
  'investments.annualIncomeHelp': 'Använd bara när leverantören dokumenterar att årsbeskedets ränta är en rapporteringsuppgift utan egen kontantbetalning, nya andelar eller ändring i bokfört eller skattemässigt anskaffningsvärde. Ingen kontering skapas.',
  'investments.liquidation': 'Likvidationsavräkning',
  'investments.fee_redemption': 'Inlösen för fondarvode',
  'investments.transfer': 'Depåflytt',
  'investments.split': 'Split eller byte av andelsklass',
  'investments.demerger': 'Delning',
  'investments.cost_basis_adjustment': 'Ändring av anskaffningsvärde',
  'investments.valuation': 'Värdering',
  'investments.targetInstrumentId': 'Mottagande investering',
  'investments.bookCostAdjustment': 'Ändring redovisningsmässigt anskaffningsvärde',
  'investments.bookValueAdjustment': 'Ändring bokfört värde',
  'investments.taxCostAdjustment': 'Ändring skattemässigt anskaffningsvärde',
  'investments.adjustmentAccount': 'Motkonto',
  'investments.demergerHelp': 'Ange dokumenterat antal och anskaffningsvärden som överförs från den här investeringen till den mottagande investeringen. Händelsen ger ingen vinst, förlust eller bankrörelse.',
  'investments.costBasisAdjustmentHelp': 'Använd belopp med tecken. Ändring i bokfört värde kräver ett dokumenterat motkonto.',
  'investments.yearEndAssessment': 'Bedömning vid årets slut',
  'investments.yearEndAssessmentHelp': 'Bekräfta med dokumentation att innehavet förs vidare till anskaffningsvärde och att det inte finns grund för nedskrivning.',
  'investments.saveYearEndAssessment': 'Spara bedömning',
  'investments.transferHelp': 'Flytta hela anskaffningsposten. Historiskt anskaffningsvärde bevaras och ingen bankkontering skapas.',
  'investments.openingHelp': 'Registrera innehavet som redan ingår i den ingående balansen. Detta skapar ingen ny kontering. Stäm av mot huvudboken.',
  'investments.dividendTaxFraction': 'Skattepliktig andel av utdelningen',
  'investments.dividendThree': '3 % – ordinarie fritaksmetode',
  'investments.dividendZero': '0 % – dokumenterat undantag',
  'investments.valuationTreatment': 'Typ av skatteskillnad',
  'investments.temporary': 'Temporär skillnad',
  'investments.permanent': 'Permanent skillnad',
  'investments.saveDraft': 'Spara',
  'investments.uploadFirst': 'Ladda upp dokumentation via Dokumentation eller Dokument i inställningarna.',
  'investments.loading': 'Hämtar investeringsregistret …',
  'investments.unavailable': 'Registret kunde inte hämtas.',
  'investments.supportScope': 'Norska AS, NOK och NRS 8, inkomståren 2024–2026. Oklar eller sammansatt skattebehandling kräver granskning.',
  'investments.holdings': 'Innehav',
  'investments.events': 'Händelser',
  'investments.closing': 'Avstämning och bokslut',
  'investments.eventsHelp': 'Köp, försäljningar och andra dokumenterade ändringar i investeringsregistret.',
  'investments.noEvents': 'Inga händelser i perioden',
  'investments.noEventsHelp': 'Nya köp och andra ändringar visas här när de är registrerade eller hämtade från investeringsinkorgen.',
  'investments.ai': 'AI-behandling',
  'investments.aiBatchTitle': 'AI-behandling av investeringar',
  'investments.aiBatchIntro': 'Ladda upp hela årets investeringsunderlag samlat. Plumme läser dokumenten, skiljer händelser från kontrollunderlag och samlar det som måste kontrolleras.',
  'investments.aiBatchLockedHelp': 'Massuppladdning och samlad AI-behandling kräver ett aktivt Plumme-abonnemang. Inkorgen och manuell registrering är fortfarande tillgängliga.',
  'investments.aiBatchActivate': 'Se abonnemang',
  'investments.aiBatchUpload': 'Ladda upp alla dokument',
  'investments.aiBatchSourceOpening': 'IB och föregående årsbesked',
  'investments.aiBatchSourceTransactions': 'Köp, försäljning, delning och anskaffningsvärdesändringar',
  'investments.aiBatchSourceBank': 'Kontoutdrag och arvoden',
  'investments.aiBatchSourceAnnual': 'Årsbesked eller decemberrapport',
  'investments.aiBatchSummary': 'Status för AI-behandlingen',
  'investments.aiBatchDocuments': 'Lästa dokument',
  'investments.aiBatchPrepared': 'Förberett',
  'investments.aiBatchEvidence': 'Kontrollunderlag',
  'investments.aiBatchExceptions': 'Undantag',
  'investments.aiBatchProposalTitle': 'Samlat arbetsunderlag',
  'investments.aiBatchProposalHelp': 'Alla tolkade rader visas samlat. Använd pennan för att rätta en källuppgift. Ingenting bokförs innan förslaget är godkänt.',
  'investments.aiBatchEmpty': 'Ladda upp dokumenten för att bygga det samlade arbetsunderlaget.',
  'investments.aiBatchOpenArchive': 'Öppna dokumentarkivet',
  'investments.aiBatchApprovalLater': 'Samlat bokföringsförslag och slutgodkännande byggs i nästa steg.',
  'investments.aiBatchPostingTitle': 'Samlat bokföringspaket',
  'investments.aiBatchPostingHelp': 'Detta är den faktiska föreslagna bokföringen. Källuppgifter kan redigeras; FIFO, vinst/förlust och konteringar beräknas på nytt.',
  'investments.aiBatchPreparing': 'Bygger bokföringspaketet …',
  'investments.aiBatchNoDrafts': 'Inga obehandlade händelseutkast är klara för bokföring.',
  'investments.aiBatchRefreshPackage': 'Beräkna på nytt',
  'investments.aiBatchFinalApprove': 'Godkänn hela investeringspaketet',
  'investments.debit': 'Debet',
  'investments.credit': 'Kredit',
  'investments.fifo': 'FIFO-poster',
  'investments.yearEndBankMissing': 'Bankkoppling saknas.',
  'investments.yearEndBankAmbiguous': 'Bankkopplingen är tvetydig.',
  'investments.yearEndBankMatchFailed': 'Bankkopplingen kunde inte sparas.',
  'investments.missing_tax_realization_confirmation': 'Skattemässig realisationsbekräftelse saknas.',
  'investments.missingTaxRealizationOverrideHelp': 'Decemberrapporten dokumenterar inte skattemässiga realisationer. Ladda upp års-/realisationsbeskedet, eller dokumentera varför du åsidosätter den här kontrollen.',
  'investments.overrideReason': 'Motivering och konsekvens',
  'investments.recordOverride': 'Registrera spårbar åsidosättning',
  'investments.aiBatchStatus.prepared': 'Klar för förslag',
  'investments.aiBatchStatus.draft': 'Utkast',
  'investments.aiBatchStatus.posted': 'Bokförd',
  'investments.aiBatchStatus.evidence': 'Kontrollunderlag',
  'investments.aiBatchStatus.exception': 'Måste klargöras',
  'investments.investmentAiBatchSubscriptionRequired': 'Aktivt abonnemang krävs för samlad AI-behandling.',
  'investments.refresh': 'Uppdatera',
  'investments.edit': 'Redigera',
  'investments.empty': 'Registrera en investering och lägg till ingående innehav eller ett köp.',
  'investments.status': 'Status',
  'investments.actions': 'Åtgärder',
  'investments.draft': 'Utkast',
  'investments.posted': 'Godkänd',
  'investments.reversed': 'Återförd',
  'investments.preview': 'Se bokföringsförslag',
  'investments.discard': 'Ta bort utkast',
  'investments.reverse': 'Återför händelse',
  'investments.reconciliation': 'Avstämning mot huvudboken',
  'investments.ledgerValue': 'Huvudbok',
  'investments.difference': 'Avvikelse',
  'investments.closingHelp': 'Registrera en dokumenterad värdering per 31 december för varje innehav. Avvikelser och öppna utkast måste lösas innan skatteskillnaderna förs över till bokslutet. Innehavet förs vidare till nästa år.',
  'investments.taxDifferences': 'Skatteskillnader',
  'investments.note': 'Underlag för värdepappersnot',
  'investments.reviewNote': 'Kommentar till kontrollen',
  'investments.reviewClosing': 'Godkänn avstämning och för över skatteskillnader',
  'investments.closingReviewed': 'Investeringsunderlaget är kontrollerat och överfört.',
  'investments.proposal': 'Bokföringsförslag',
  'investments.noJournal': 'Uppdaterar registret utan ny huvudbokskontering.',
  'investments.bookProfit': 'Redovisningsmässigt resultat',
  'investments.taxProfit': 'Skattemässigt resultat',
  'investments.approve': 'Godkänn och bokför',
  'investments.existingPostingTitle': 'Redan bokförd',
  'investments.existingPostingHelp': 'Den här huvudbokskonteringen stäms av samlat mot händelserna på datumet. Koppla händelserna utan att bokföra på nytt.',
  'investments.existingPostingNote': 'Kontrollanteckning',
  'investments.linkExistingPosting': 'Koppla till {{voucher}} ({{count}} händelser)',
  'investments.reverseHelp': 'Senare godkända händelser måste återföras först. Återföringen förs i den ursprungliga öppna perioden och behålls i historiken.',
  'investments.confirmReverse': 'Bekräfta återföring',
  'investments.evidenceRequired': 'Dokumentation och unik referens saknas.',
  'investments.quantityRequired': 'Ange ett positivt antal.',
  'investments.lotQuantityInvalid': 'Antalet överstiger innehavet. Skattemässigt anskaffningsvärde beräknas med FIFO.',
  'investments.feeMustMatchRedemption': 'Arvode och inlösenbelopp måste vara lika.',
  'investments.dividendFeesReview': 'Utdelning med kostnader måste hanteras separat.',
  'investments.fullLotTransferRequired': 'Välj hela anskaffningsposten och nytt depå.',
  'investments.positionRequired': 'Registrera innehavet först.',
  'investments.valuationTaxReview': 'Värderingens skattebehandling måste klargöras.',
  'investments.annualIncomeScopeReview': 'Årsrapporterad ränteuppgift stöds bara för dokumenterade, fullt skattepliktiga fonder.',
  'investments.annualIncomeDateRequired': 'Årsrapporterad ränteuppgift måste dateras 31 december.',
  'investments.taxReviewRequired': 'Kontrollera och dokumentera skattebehandlingen.',
  'investments.bankAccountRequired': 'Välj ett aktivt bankkonto.',
  'investments.demergerTargetRequired': 'Välj en annan mottagande investering för delningen.',
  'investments.demergerBasisInvalid': 'Anskaffningsvärdena som flyttas får inte överstiga innehavets underlag.',
  'investments.demergerMeasurementUnsupported': 'Delning stöds för närvarande bara för investeringar värderade till anskaffningsvärde.',
  'investments.basisAdjustmentRequired': 'Ange minst en ändring av anskaffningsvärdet.',
  'investments.basisAdjustmentInvalid': 'Ändringen av anskaffningsvärdet skulle ge negativt underlag.',
  'investments.basisAdjustmentMeasurementUnsupported': 'Ändring av anskaffningsvärde stöds för närvarande bara för investeringar värderade till anskaffningsvärde.',
  'investments.adjustmentAccountRequired': 'Välj motkonto när bokfört värde ändras.',
  'investments.openingYearInvalid': 'Årsbeskedet kan bara användas som IB för rapportåret eller nästa år när rapportdatumet är 31.12.',
  'investments.unbalanced': 'Förslaget balanserar inte.',
  'investments.dateInvalid': 'Välj ett giltigt datum.',
  'investments.scopeUnsupported': 'Det här flödet stöder norska AS 2024–2026.',
  'investments.amountRequired': 'Ett nödvändigt belopp saknas.',
  'investments.amountInvalid': 'Kontrollera beloppet.',
  'investments.instrumentInvalid': 'Kontrollera investeringens typ, konto och regelverk.',
  'investments.instrumentReviewRequired': 'Dokumentera investeringens skattebehandling.',
  'investments.evidenceNotFound': 'Dokumentationen finns inte i det här företaget.',
  'investments.eventInvalid': 'Ogiltig händelse.',
  'investments.dividendFractionInvalid': 'Välj en dokumenterad skattepliktig andel.',
  'investments.instrumentHasHistory': 'Investeringen har godkända händelser. Historiken kan inte ändras direkt.',
  'investments.issuerCountryRequired': 'Ange emittentens land.',
  'investments.instrumentNotFound': 'Investeringen finns inte.',
  'investments.eventImmutable': 'Använd återföring för godkända händelser.',
  'investments.duplicateEvent': 'En händelse med den här referensen är redan registrerad.',
  'investments.eventNotFound': 'Händelsen finns inte.',
  'investments.chronologyRequired': 'Godkänn händelserna i datumordning.',
  'investments.openingMustPrecedeActivity': 'Ingående innehav måste dateras 1 januari före andra händelser.',
  'investments.proposalStale': 'Underlaget har ändrats. Hämta ett nytt förslag.',
  'investments.reverseLatestFirst': 'Återför den senast godkända händelsen först.',
  'investments.existingPostingMismatch': 'Den befintliga konteringen stämmer inte med den samlade investeringsavräkningen.',
  'investments.existingPostingUnlinkRequired': 'Ta bort kopplingen till den befintliga huvudbokskonteringen innan händelsen återförs.',
  'investments.reasonRequired': 'Skriv en motivering.',
  'investments.actionInvalid': 'Åtgärden stöds inte.',
  'investments.documentPostedCannotDelete': 'Ett bokfört investeringsdokument kan inte flyttas till papperskorgen.',
  'investments.documentInUseCannotTrash': 'Dokumentet används av ett investeringsutkast. Ta bort utkastet innan dokumentet flyttas till papperskorgen.',
  'investments.sourceReviewedConfirmation': 'Jag har visuellt kontrollerat originaldokumentet mot belopp, datum, fond och antal.',
  'investments.draftsPending': 'Det finns obehandlade utkast.',
  'investments.ledgerMismatch': 'Register och huvudbok stämmer inte.',
  'investments.valuationRequired': 'Årets värdering saknas för',
  'investments.holdingQuantityMismatch': 'Dokumenterat årsinnehav stämmer inte med antalet andelar i registret för',
  'investments.closingReviewRequired': 'Investeringsunderlaget måste kontrolleras före bokslut.',
  'investments.taxPackageChanged': 'Skatteskillnaderna har ändrats. Stäm av och överför på nytt.',
  'investments.useInvestmentWorkflow': 'Ändra denna kontering via Investeringar.',
});
